import Config from "./Config"

export function transformImageUri(url) {
    return Config.strapiUrl + url;
}